import React from 'react'
import styled from 'styled-components'

function Viewers() {
    return (
        <Container>
           
            <Wrap2>
                <a href="https://twitter.com/mamuthafar1">
                <img src="/images/twitter.png" alt="تويتر المحامي محمد المظفر" />
                </a>
            </Wrap2>

            <Wrap3>
                <a href="https://www.youtube.com/channel/UCv-sb4_FWF-mOHo6WISNw2Q">
                <img src="/images/youtube.png" alt="يوتيوب المحامي محمد المظفر" />
                </a>
            </Wrap3>

            <Wrap4>
                <a href="https://www.instagram.com/mamuthafar1/">
                <img src="/images/insta.png" alt="انستقرام المحامي محمد المظفر" />
                </a>
            </Wrap4>

            <Wrap5>
                <a href="https://www.snapchat.com/add/mamuthafar1">
                <img src="/images/snap.png" alt="سناب المحامي محمد المظفر" />
                </a>
            </Wrap5>
        </Container>
    )
}

export default Viewers


const Container = styled.div`
    margin-top: 30px;
    display: grid;
    padding: 30px ;
    grid-gap: 25px;
    grid-template-columns: repeat(4, minmax(0, 1fr));

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        display: grid;
        grid-gap: 25px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
        
     
      }

      @media only screen and (max-width: 479px) {
        display: grid;
        grid-gap: 25px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
      }
`

const Wrap2 = styled.div`
    border: 3px solid rgba(249, 249, 249, 0.1);
    border-radius: 10px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        margin-top: 25px;
         
      
       }

       @media only screen and (max-width: 479px) {

        margin-top: 25px;
        
      }


    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
        background-image: url("/images/twitterblue.png");
        background-size: 100%;

    }


`

const Wrap3 = styled.div`
    border: 3px solid rgba(249, 249, 249, 0.1);
    border-radius: 10px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        margin-top: 25px;
         
      
       }

       @media only screen and (max-width: 479px) {

        margin-top: 25px;
        
      }


    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
        background-image: url("https://i.ytimg.com/vi/fOoeCpN6mmY/maxresdefault.jpg");
        background-size: 100%;

    }


`

const Wrap4 = styled.div`
    border: 3px solid rgba(249, 249, 249, 0.1);
    border-radius: 10px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        margin-top: 25px;
         
      
       }

       @media only screen and (max-width: 479px) {

        margin-top: 25px;
        
      }


    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
        background-image: url("https://lotofcolor.com/wp-content/uploads/2020/11/thumbnail-3.png");
        background-size: 100%;

    }


`

const Wrap5 = styled.div`
    border: 3px solid rgba(249, 249, 249, 0.1);
    border-radius: 10px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        margin-top: 25px;
         
      
       }

       @media only screen and (max-width: 479px) {

        margin-top: 25px;
        
      }


    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
        background-image: url("https://www.color-name.com/color-image?c=FFFC00&desktop");
        background-size: 100%;

    }


`